import { type EmojiId } from '@app/client/common/structs/emoji/emoji';
import {
    type InFlightTransfers,
    type TransferData,
    type TransfersResponse,
    type UserPendingIncoming,
} from '@app/client/common/structs/emoji/transfers';

export const ACTION_SET_INCOMING_TRANSFERS = 'ACTION_SET_INCOMING_TRANSFERS';
export const ACTION_SET_OUTGOING_TRANSFERS = 'ACTION_SET_OUTGOING_TRANSFERS';
// export const ACTION_SET_MINT_NFT_PANEL_OPEN = 'ACTION_SET_MINT_NFT_PANEL_OPEN';
export const ACTION_SET_TRANSFER_PANEL_OPEN = 'ACTION_SET_TRANSFER_PANEL_OPEN';
// export const ACTION_SET_TRANSFER_STATUS = 'ACTION_SET_TRANSFER_STATUS';
export const ACTION_SET_PENDING_INCOMING = 'ACTION_SET_PENDING_INCOMING';
// export const ACTION_SET_TRANSFER_ID = 'ACTION_SET_TRANSFER_ID';
export const ACTION_SET_TRANSFER_DATA = 'ACTION_SET_TRANSFER_DATA';

export interface TransfersState {
    incomingTransfers: TransfersResponse[];
    outgoingTransfers: TransfersResponse[];
    transferPanelOpen: boolean;
    userPendingIncoming: UserPendingIncoming;
    transferData: InFlightTransfers;
}

interface SetIncomingTransfers {
    type: typeof ACTION_SET_INCOMING_TRANSFERS;
    incomingTransfers: TransfersResponse[];
}

interface SetOutgoingTransfers {
    type: typeof ACTION_SET_OUTGOING_TRANSFERS;
    outgoingTransfers: TransfersResponse[];
}

/*
interface SetMintNftPanelOpen {
    type: typeof ACTION_SET_MINT_NFT_PANEL_OPEN;
    mintNftPanelOpen: boolean;
}
*/

interface SetTransferPanelOpen {
    type: typeof ACTION_SET_TRANSFER_PANEL_OPEN;
    transferPanelOpen: boolean;
}

interface SetPendingIncoming {
    type: typeof ACTION_SET_PENDING_INCOMING;
    userPendingIncoming: UserPendingIncoming;
}

interface SetTransferData {
    type: typeof ACTION_SET_TRANSFER_DATA;
    emojiId: EmojiId;
    transferData: TransferData;
}

export type TransfersActionTypes =
    | SetIncomingTransfers
    // | SetMintNftPanelOpen
    | SetOutgoingTransfers
    | SetTransferPanelOpen
    | SetPendingIncoming
    | SetTransferData;
